export const customStyles = {
  menu: (base) => ({ ...base, zIndex: 9999 }),
  valueContainer: (baseStyles) => ({
    ...baseStyles,
    maxHeight: "3.5vw",
    overflowY: "auto",
  }),
  control: (baseStyles) => ({ ...baseStyles, flexWrap: "nowrap" }),
};

export const PRESENTATION_OPTIONS = Object.freeze(
  [
    { value: "CAP", label: "Cápsulas" },
    { value: "TAB", label: "Tabletas" },
    { value: "SFG", label: "Softgel" },
    { value: "GUM", label: "Gummies" },
    { value: "PWD", label: "Polvo" },
    { value: "LIQ", label: "Líquido" },
    { value: "SHT", label: "Shot bebible" },
    { value: "EFF", label: "Efervescente" },
    { value: "STR", label: "Tiras orales" },
    { value: "SCW", label: "Discos blandos" },
    { value: "SPY", label: "Spray oral" },
    { value: "STK", label: "Stick pack" },
    { value: "SCH", label: "Sachet" },
    { value: "DRP", label: "Gotas" },
    { value: "CRM", label: "Crema" },
    { value: "SRM", label: "Sérum" },
    { value: "GEL", label: "Gel" },
    { value: "AMP", label: "Ampolla" },
    { value: "MSK", label: "Mascarilla" },
    { value: "FSP", label: "Spray facial" },
    { value: "STB", label: "Stick cosmético" },
    { value: "PTC", label: "Parche" },
    { value: "LOC", label: "Loción" },
    { value: "UND", label: "Unidad" },
  ].map(Object.freeze),
);

export const UNIT_WEIGHT_OPTIONS = Object.freeze(
  [
    { value: "KG", label: "Kilogramos (kg)" },
    { value: "G", label: "Gramos (g)" },
    { value: "LB", label: "Libras (lb)" },
    { value: "OZ", label: "Onzas (oz)" },
  ].map(Object.freeze),
);

export const UNIT_DIMENSIONS_OPTIONS = Object.freeze(
  [
    { value: "CM", label: "Centímetros (cm)" },
    { value: "M", label: "Metros (m)" },
    { value: "IN", label: "Pulgadas (in)" },
    { value: "FT", label: "Pies (ft)" },
  ].map(Object.freeze),
);

export const CURRENCY_OPTIONS = Object.freeze(
  [
    { value: "MXN", label: "MXN" },
    { value: "USD", label: "USD" },
    { value: "PEN", label: "PEN" },
    { value: "COP", label: "COP" },
  ].map(Object.freeze),
);

export const REGEX = {
  NAME_WITH_ACCENTS: /^[A-Za-z0-9áéíóúÁÉÍÓÚñÑ]+(?: [A-Za-z0-9áéíóúÁÉÍÓÚñÑ]+)*$/,
  ALPHANUMERIC: /^[A-Za-z0-9]+$/,
  ALPHANUMERIC_WITH_SPACES: /^[A-Za-z0-9 ]+$/,
  NUMERIC: /^\d+$/,
  CODE_S_FORMAT: /^S-\d{5}$/i,
  NUMERIC_WITH_DOC: /^\d+(\.\d{1,2})?$/,
  ONLY_LETTERS: /^[A-Za-z]+$/,
  LETTERS_WITH_ACCENTS: /^[A-Za-záéíóúÁÉÍÓÚñÑ]+$/,
  LETTERS_AND_SPACES: /^[A-Za-záéíóúÁÉÍÓÚñÑ]+(?: [A-Za-záéíóúÁÉÍÓÚñÑ]+)*$/,
};

const UNIT_DIMENSIONS_OPTIONS_LABELS = Object.freeze({
  CM: "Centímetros",
  MT: "Metros",
  IN: "Pulgadas",
  FT: "Pies",
});

const UNIT_WEIGHT_OPTIONS_LABELS = Object.freeze({
  KG: "Kilogramos",
  GR: "Gramos",
  LB: "Libras",
  OZ: "Onzas",
});

export const productDetailsLabels = (element) => [
  {
    title: "Información general",
    details: [
      {
        label: "Remitente",
        value: element?.company?.description || "",
      },
      {
        label: "Categoría",
        value: element?.category?.name || "",
      },
      {
        label: "Subcategoría",
        value: element?.subCategory?.subCategoryName || "",
      },
      {
        label: "Presentación",
        value: element?.presentation || "",
      },
    ],
  },
  {
    title: "Identificación del producto",
    details: [
      {
        label: "Nombre del producto",
        value: element?.name || "",
        space: 12,
      },
      {
        label: "Abreviatura",
        value: element?.abbreviation || "",
        space: 12,
      },
      {
        label: "Descripción",
        value: element?.description || "",
        space: 12,
      },
      {
        label: "ID Externo (SKU)",
        value: element?.sku || "N/A",
      },
      {
        label: "Ítem Master",
        value: element?.masterSku || "N/A",
      },
    ],
  },
  {
    title: "Dimensiones y peso",
    details: [
      {
        label: "Unidad de peso",
        value: UNIT_WEIGHT_OPTIONS_LABELS[element?.unitWeight?.toUpperCase()] || "",
      },
      {
        label: "Peso",
        value: `${element?.weight || ""} ${UNIT_WEIGHT_OPTIONS_LABELS[element?.unitWeight] || ""}`,
      },
      {
        label: "Unidad (Dimensiones)",
        value: UNIT_DIMENSIONS_OPTIONS_LABELS[element?.unitDimensions?.toUpperCase()] || "",
        space: 12,
      },
      {
        label: "Ancho",
        value: `${element?.width || ""} ${UNIT_DIMENSIONS_OPTIONS_LABELS[element?.unitDimensions] || ""}`,
      },
      {
        label: "Alto",
        value: `${element?.height || ""} ${UNIT_DIMENSIONS_OPTIONS_LABELS[element?.unitDimensions] || ""}`,
      },
      {
        label: "Largo",
        value: `${element?.length || ""} ${UNIT_DIMENSIONS_OPTIONS_LABELS[element?.unitDimensions] || ""}`,
      },
    ],
  },
  {
    title: "Unidades de medida",
    details: [
      {
        label: "Unidad de medida para recibo",
        value: element?.receiptUnitMeasure || "N/A",
      },
      {
        label: "Unidad de medida para despacho",
        value: element?.dispatchUnitMeasure || "N/A",
      },
    ],
  },
  {
    title: "Información comercial",
    details: [
      {
        label: "Moneda",
        value: element?.currency || "",
        space: 12,
      },
      {
        label: "Costo por unidad de producto",
        value: element?.pricePerUnit ? `$${element.pricePerUnit}` : "",
      },
      {
        label: "Valor comercial por unidad",
        value: element?.price ? `$${element?.price}` : "",
      },
    ],
  },
  {
    title: "Vida útil",
    details: [
      {
        label: "Vida útil (días)",
        value: element?.shelfLifeDays ? `${element.shelfLifeDays} días` : "N/A",
      },
      {
        label: "Plazo máximo para despachar",
        value: element?.maxDispatchDays
          ? `${element.maxDispatchDays} días`
          : "N/A",
      },
    ],
  },
];

export const mapToOptions = (items, valueKey, labelKey) =>
  items?.map((item) => ({
    value: item[valueKey],
    label: item[labelKey],
    additionalInfo: item
  })) ?? [];
